import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export const validatePasswordMatch: ValidatorFn = (
  formGroup: AbstractControl,
): ValidationErrors | null => {
  const password = formGroup.get('password')?.value;
  const passwordConfirm = formGroup.get('passwordConfirm')?.value;
  return password === passwordConfirm ? null : { passwordsMismatch: true };
};

export function validateEndDateBeforeStartDate(group: FormGroup) {
  const startDate = group.get('start_date')?.value;
  const endDate = group.get('end_date')?.value;

  if (startDate && endDate && endDate < startDate) {
    return { endDateBeforeStartDate: true };
  }
  return null;
}